import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appParagraph]',
  standalone: true,
})
export class ParagraphDirective implements OnInit {
  @Input() appParagraph: number = 2;
  @Input() paragraphBold: string = "false";

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  ngOnInit(): void {
    let classes = [];

    if (this.appParagraph == 1)
      classes.push('fs-4');
    if (this.appParagraph == 2)
      classes.push('fs-5');
    if (this.appParagraph == 3)
      classes.push('fs-6');

    if (this.paragraphBold == "true")
      classes.push('fw-bold');

    classes.forEach((className) => {
      this.renderer.addClass(this.el.nativeElement, className);
    });
  }
}
